import React, { useState } from "react";
import { followupAdd } from "../../api/FollowUps";
import { closeModal, SweetAlertShow } from "../master/Master";

export default function FollowUpModal({ data, setLoading, handleFunction }) {
    const [error, setError] = useState("");
    const [loading, Setloading] = useState("");

    const handleAdd = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const formData = new FormData(e.target);
            const response = await followupAdd(formData);
            if (response?.data?.status) {
                closeModal("feefollowup");
                e?.target?.reset();
                SweetAlertShow("success", "Successfully", response?.data?.message);
            } else {
                SweetAlertShow("info", "warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.response?.message ??
                error?.message
            );
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div
                className="modal fade"
                id="feefollowup"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <form onSubmit={handleAdd}>
                            <div className="modal-header bg-label-primary py-3">
                                <h1 className="modal-title fs-5">Follow Up Response</h1>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div className="col-xl-12 mb-12 mb-xl-0">
                                    <div className="">
                                        <h5 className="card-header pb-6">Basic Timeline</h5>
                                        <div
                                            className="card-body"
                                            style={{
                                                maxHeight: "250px",
                                                overflowY: "auto",
                                                border: "1px solid #e0e0e0",
                                                borderRadius: "6px",
                                                padding: "1rem",
                                            }}
                                        >

                                            <ul className="timeline mb-0">

                                                {(() => {

                                                    // Latest followups first
                                                    const studentFollowups =
                                                        [...(data?.followups || [])];

                                                    // Default followup always last and number 1
                                                    const defaultFollowup = {
                                                        id: "default",
                                                        followup_date: data?.data?.admission_date,
                                                        next_followup_date: data?.data?.next_payment_date,
                                                        response: `Fees Pending ₹${data?.data?.left_amount || 0}`,
                                                    };

                                                    // Sabse niche default followup
                                                    const allFollowups = [
                                                        ...studentFollowups,
                                                        defaultFollowup,
                                                    ];

                                                    return allFollowups.length > 0 ? (

                                                        allFollowups.map((resp, index) => {

                                                            // numbering
                                                            const followupNumber =
                                                                resp?.id === "default"
                                                                    ? 1
                                                                    : allFollowups.length - index;

                                                            return (

                                                                <li
                                                                    key={resp?.id || index}
                                                                    className="timeline-item timeline-item-transparent"
                                                                >

                                                                    <span className="timeline-point timeline-point-primary"></span>

                                                                    <div className="timeline-event">

                                                                        <div className="timeline-header mb-2">

                                                                            <h6 className="mb-0">
                                                                                Follow-up #{followupNumber}
                                                                            </h6>

                                                                            <small className="text-muted">
                                                                                {resp?.followup_date || "—"}
                                                                            </small>

                                                                        </div>

                                                                        <p className="mb-2">
                                                                            <strong>Response:</strong>{" "}
                                                                            {resp?.response || "—"}
                                                                        </p>

                                                                        <p className="mb-0">
                                                                            <strong>Next Follow-Up:</strong>{" "}
                                                                            {resp?.next_followup_date || "—"}
                                                                        </p>

                                                                    </div>

                                                                </li>

                                                            );

                                                        })

                                                    ) : (

                                                        <li className="timeline-item timeline-item-transparent">

                                                            <span className="timeline-point timeline-point-secondary"></span>

                                                            <div className="timeline-event">

                                                                <div className="timeline-header mb-2">
                                                                    <h6 className="mb-0">
                                                                        No follow-ups yet
                                                                    </h6>
                                                                </div>

                                                                <p className="mb-0">
                                                                    This student has no recorded responses.
                                                                </p>

                                                            </div>

                                                        </li>

                                                    );

                                                })()}

                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <input
                                    type="hidden"
                                    value={data?.student?.id}
                                    name="user_id"
                                />

                                <input
                                    type="hidden"
                                    name="type"
                                    value='fees'
                                />


                                {/* Student Name */}
                                <div className="row mt-4">
                                    <div className="form-floating col-md-4 form-floating-outline mb-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            defaultValue={data?.student?.name}
                                            id="studentName"
                                            placeholder="Enter Name"
                                            readOnly
                                        />
                                        <label htmlFor="studentName" className="fw-semibold">
                                            Name
                                        </label>
                                    </div>



                                    {/* Follow-Up Dates */}
                                    <div className="form-floating col-md-4 form-floating-outline mb-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="date"
                                            id="followupDate"
                                            defaultValue={new Date().toISOString().split("T")[0]}
                                            placeholder="Follow-Up Date"
                                            required
                                            readOnly
                                        />
                                        <label htmlFor="followupDate" className="fw-semibold">
                                            Follow-Up Date
                                        </label>
                                        <span className="text-danger">{error?.date ?? ""}</span>
                                    </div>
                                    <div className="form-floating col-md-4 form-floating-outline mb-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="next_followup_date"
                                            id="nextFollowupDate"
                                            placeholder="Next Follow-Up Date"
                                            defaultValue={
                                                new Date(Date.now() + 86400000)
                                                    .toISOString()
                                                    .split("T")[0]
                                            } // 👈 tomorrow's date
                                            min={new Date().toISOString().split("T")[0]}
                                            required
                                        />
                                        <label htmlFor="nextFollowupDate" className="fw-semibold">
                                            Next Follow-Up Date
                                        </label>
                                        <span className="text-danger">
                                            {error?.next_followup_date ?? ""}
                                        </span>
                                    </div>

                                    {/* Response Textarea */}
                                    <div className="form-floating form-floating-outline mb-4">
                                        <textarea
                                            type="text"
                                            className="form-control input-uppercase"
                                            name="response"
                                            id="remark"
                                            style={{ height: "100px" }}
                                            placeholder="e.g., Will pay next week, not picking up..."
                                            required
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                e.target.value = value
                                                    .split(" ")
                                                    .map(
                                                        (word) =>
                                                            word.charAt(0).toUpperCase() +
                                                            word.slice(1).toLowerCase()
                                                    )
                                                    .join(" ");
                                            }}
                                        ></textarea>
                                        <label htmlFor="remark" className="fw-semibold">
                                            Response
                                        </label>
                                        <span className="text-danger">{error?.response ?? ""}</span>
                                    </div>
                                </div>
                            </div>

                            {/* 🔽 Footer Buttons */}
                            <div className="modal-footer bg-label-primary py-3">
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary px-5"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        "Submit"
                                    )}
                                    {loading ? " Submitting..." : ""}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}
